module.exports = __webpack_public_path__ + "static/media/Host Asset 12.f197effd.svg";